var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6072 21.3803L10.3793 21.5C9.95372 21.5412 9.56418 21.2464 9.5043 20.8356L6.82325 2.31094C6.74469 1.76817 7.08659 1.27625 7.58301 1.22024L9.50173 1.00519C10.0007 0.94917 10.4521 1.35352 10.5049 1.9008L12.3051 20.5613C12.345 20.9746 12.0334 21.3391 11.6072 21.3803Z",
    fill: "#FCCF3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41997 22.7875L7.20049 22.8481C6.77747 22.8693 6.39952 22.5622 6.35188 22.1578L4.20652 3.92167C4.14342 3.38791 4.49626 2.92497 4.99011 2.89728L6.89594 2.78847C7.39108 2.76014 7.82697 3.17801 7.86367 3.71435L9.13273 22.0188C9.1617 22.425 8.84299 22.7663 8.41997 22.7875Z",
    fill: "#EFC03C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59716 24.0641L5.40215 24.2019C4.98815 24.2495 4.59024 23.9733 4.50847 23.5799L0.852604 5.88716C0.745722 5.37013 1.05156 4.89303 1.53317 4.82929L3.39265 4.58333C3.87619 4.51894 4.33977 4.89625 4.42154 5.41778L7.23394 23.2638C7.2964 23.6604 7.01246 24.0158 6.59716 24.0641Z",
    fill: "#FCCF3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3925 21.3806L15.6204 21.5004C16.046 21.5416 16.4355 21.2467 16.4954 20.8359L19.1771 2.31192C19.2556 1.76914 18.9144 1.27659 18.4173 1.22121L16.4986 1.00616C15.9996 0.950146 15.5482 1.35449 15.4955 1.90178L13.6952 20.5616C13.6546 20.975 13.9656 21.3394 14.3925 21.3806Z",
    fill: "#FCCF3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5796 22.7875L18.7991 22.8481C19.2221 22.8693 19.6 22.5622 19.6477 22.1578L21.7931 3.92167C21.8562 3.38791 21.5033 2.92497 21.0095 2.89728L19.1036 2.78847C18.6085 2.76014 18.1732 3.17801 18.1359 3.71435L16.8662 22.0188C16.8385 22.425 17.1559 22.7663 17.5796 22.7875Z",
    fill: "#EFC03C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4024 24.064L20.598 24.2018C21.012 24.2494 21.4099 23.9732 21.4917 23.5798L25.1469 5.88703C25.2538 5.37001 24.948 4.89291 24.4664 4.82916L22.6069 4.58321C22.1233 4.51947 21.6598 4.89613 21.578 5.41766L18.7656 23.263C18.7025 23.6603 18.9871 24.0157 19.4024 24.064Z",
    fill: "#FCCF3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4182 23.3789H12.2C11.777 23.3789 11.4293 23.057 11.419 22.6546L10.9554 4.51818C10.9419 3.98699 11.3347 3.5498 11.8291 3.5498H13.7337C14.2282 3.5498 14.6222 3.98699 14.61 4.51818L14.1973 22.6546C14.1883 23.057 13.8412 23.3789 13.4182 23.3789Z",
    fill: "#EFC03C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4705 25.0471L12.3515 25.5062C11.9632 25.6652 11.5145 25.5055 11.3432 25.1449L3.64258 8.94081C3.41723 8.46692 3.60137 7.92286 4.05337 7.73356L5.79567 7.00471C6.2483 6.81541 6.78464 7.05879 6.98681 7.54362L13.8948 24.0974C14.0494 24.4657 13.8594 24.888 13.4705 25.0471Z",
    fill: "#FCCF3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4821 27.9405L12.2742 27.9966C11.8551 28.0159 11.4861 27.7139 11.4462 27.3173L9.64727 9.46677C9.59448 8.9446 9.95118 8.49389 10.4405 8.46814L12.3264 8.36834C12.8164 8.34258 13.2394 8.75208 13.2671 9.27619L14.202 27.1891C14.2226 27.5871 13.9019 27.9212 13.4821 27.9405Z",
    fill: "#EFC03C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6942 24.9467L19.8679 24.9995C20.2749 25.0182 20.6406 24.7323 20.6876 24.3575L22.8168 7.54496C22.8786 7.05498 22.5432 6.6326 22.07 6.60814L20.2452 6.51478C19.7714 6.49031 19.3528 6.87534 19.3149 7.36661L18.0117 24.2365C17.9827 24.6132 18.2866 24.9287 18.6942 24.9467Z",
    fill: "#EFC03C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1774 27.6714L15.4523 27.8723C15.8946 27.9425 16.3112 27.6431 16.3872 27.202L19.3811 9.71339C19.4584 9.26333 19.1526 8.8371 18.7018 8.76627L16.9647 8.49263C16.514 8.42116 16.0916 8.73279 16.0266 9.18478L13.4949 26.7468C13.4305 27.1892 13.7351 27.6012 14.1774 27.6714Z",
    fill: "#FCCF3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 11.8018C18.6795 11.8018 18.4528 11.9601 18.3614 12.1984C17.534 14.3534 15.446 15.8832 12.9993 15.8832C10.5533 15.8832 8.46521 14.3527 7.63784 12.1984C7.54641 11.9601 7.31977 11.8018 7.0648 11.8018H1.44451C1.06463 11.8018 0.776178 12.1443 0.840564 12.5184L4.28395 32.4917C4.33482 32.7859 4.58979 33.0004 4.8879 33.0004H21.1126C21.4107 33.0004 21.6657 32.7859 21.7166 32.4917L25.16 12.5184C25.2244 12.1437 24.9359 11.8018 24.556 11.8018H18.9344Z",
    fill: "#F7616C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5552 11.8018H20.6907C21.0706 11.8018 21.359 12.1443 21.2947 12.5184L17.8513 32.4917C17.8004 32.7853 17.5454 32.9997 17.2473 32.9997H21.1118C21.4099 32.9997 21.6649 32.7853 21.7157 32.4917L25.1591 12.5184C25.2235 12.1443 24.9351 11.8018 24.5552 11.8018Z",
    fill: "#DC4A55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5649 21.7666H2.43457L3.1029 25.6452H22.8959L23.5649 21.7666Z",
    fill: "#F3E8D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5649 21.7666H19.6997L19.0308 25.6452H22.8959L23.5649 21.7666Z",
    fill: "#E5D8C6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0326 23.8212C18.0326 26.6007 15.7791 28.8543 12.9989 28.8543C10.2193 28.8543 7.96582 26.6007 7.96582 23.8212C7.96582 21.041 10.2193 18.7881 12.9989 18.7881C15.7791 18.7881 18.0326 21.041 18.0326 23.8212Z",
    fill: "#F1B172"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2738 19.3311C15.4116 19.7901 15.4869 20.2769 15.4869 20.781C15.4869 23.5612 13.2334 25.8141 10.4532 25.8141C9.63482 25.8141 8.86283 25.6177 8.17969 25.2707C8.8023 27.3433 10.7242 28.8538 12.9997 28.8538C15.7799 28.8538 18.0327 26.6003 18.0327 23.8207C18.0327 21.8595 16.9105 20.161 15.2738 19.3311Z",
    fill: "#E19C5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89141 2.78805L6.82251 2.31094C6.74396 1.76817 7.08585 1.27625 7.58292 1.22024L9.50163 1.00519C10.0006 0.94917 10.452 1.35352 10.5048 1.9008L11.0263 7.30411V7.3054L11.1345 8.43088",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.896 9.7207V9.72199",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46631 13.6647V13.6641",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35687 10.8268L7.86367 3.71337C7.82697 3.17767 7.39108 2.75916 6.89594 2.78749H6.89144L4.99011 2.8963C4.49626 2.92463 4.14342 3.38693 4.20652 3.92133L4.35461 5.18009V5.18073",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7409 7.44594L4.42155 5.41777C4.40867 5.33471 4.38614 5.25616 4.35459 5.18147V5.18082C4.19169 4.78742 3.79893 4.52923 3.39265 4.58332L1.53317 4.82927C1.05156 4.89302 0.745722 5.37012 0.852604 5.88714L2.07466 11.8017",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5332 13.6647V13.6641",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1567 15.7664L14.4149 13.0937V13.0931L15.4947 1.9008C15.5475 1.35352 15.9988 0.94917 16.4978 1.00519L18.4165 1.22024C18.9136 1.27625 19.2549 1.76881 19.1763 2.31159L19.1074 2.78805",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6448 5.17816V5.17752L21.7929 3.92134C21.8554 3.38693 21.5032 2.92463 21.0093 2.8963L19.1074 2.78749H19.1029C18.6084 2.75916 18.1725 3.17767 18.1358 3.71337L17.7952 8.62219",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8659 11.8018L20.8633 11.8268",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4373 13.7829V13.7822",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9248 11.8017L25.1468 5.88717C25.2537 5.37079 24.9478 4.89305 24.4662 4.8293L22.6068 4.58335C22.2011 4.52926 21.8097 4.78616 21.6448 5.17828V5.17892C21.6133 5.25425 21.5901 5.33409 21.5772 5.41779L21.395 6.57353",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3552 15.7227L14.4151 13.0938V13.0932L14.6101 4.51753C14.6224 3.98699 14.2277 3.5498 13.7338 3.5498H11.8287C11.3342 3.5498 10.9414 3.98699 10.9549 4.51753L11.0264 7.30418V7.30547",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00178 11.8018L3.64258 8.94114C3.41723 8.46726 3.60137 7.9232 4.05337 7.7339L4.74101 7.44609L5.79566 7.00569C6.2483 6.81639 6.78528 7.05977 6.98681 7.54396L7.89595 9.72151V9.7228L8.35696 10.827V10.8277L10.1521 15.128",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6103 15.8514L13.2671 9.27624C13.2394 8.75214 12.8164 8.342 12.3264 8.36839L11.1346 8.43085L10.4405 8.46755C9.95118 8.4933 9.59447 8.94401 9.64727 9.46618L10.2216 15.167",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.186 9.03094L19.3148 7.36655C19.3528 6.87529 19.7713 6.4909 20.2452 6.51472L21.3951 6.57331L21.4808 6.57782L22.0699 6.60808C22.5432 6.63255 22.8786 7.05492 22.8168 7.5449L22.2779 11.8015",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1179 15.4795L16.0258 9.18316C16.0908 8.73181 16.5125 8.42018 16.9639 8.49165L17.7951 8.62236L18.2522 8.69447L18.701 8.76529C18.8961 8.7962 19.0648 8.89342 19.1858 9.03057C19.3455 9.20956 19.4247 9.45745 19.3809 9.71242L19.0236 11.8011",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9344 11.8018C18.6795 11.8018 18.4528 11.9601 18.3614 12.1984C17.534 14.3534 15.446 15.8832 12.9993 15.8832C10.5533 15.8832 8.46521 14.3527 7.63784 12.1984C7.54641 11.9601 7.31977 11.8018 7.0648 11.8018H1.44451C1.06463 11.8018 0.776178 12.1443 0.840564 12.5184L4.28395 32.4917C4.33482 32.7859 4.58979 33.0004 4.8879 33.0004H21.1126C21.4107 33.0004 21.6657 32.7859 21.7166 32.4917L25.16 12.5184C25.2244 12.1437 24.9359 11.8018 24.556 11.8018H18.9344Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8633 11.8269C20.8085 11.8101 20.7506 11.8018 20.6907 11.8018H20.8658H22.2778H23.9249H24.5552C24.9351 11.8018 25.2235 12.1443 25.1591 12.5184L23.5649 21.7668L22.896 25.6455L21.7157 32.4917C21.6649 32.7859 21.4106 33.0004 21.1118 33.0004H17.2473",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6922 25.6452H19.0308H22.8959L23.5649 21.7666H21.8657H21.0158H19.6998H19.694H19.0005H18.2021H18.1184H17.5956H17.595H17.5956",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3124 25.6452H3.10354H3.1029L2.43457 21.7666H7.88101H7.88166",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0308 25.6452H22.8959L23.5649 21.7666H21.8657H21.0158H19.6997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4034 21.7666H7.8811",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 28.8311C15.7616 28.8311 18.0098 26.5829 18.0098 23.8096C18.0098 21.0363 15.7616 18.7881 12.9883 18.7881C10.215 18.7881 7.9668 21.0363 7.9668 23.8096C7.9668 26.5829 10.215 28.8311 12.9883 28.8311Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFries);
export default __webpack_public_path__ + "static/media/fries.c54323354d0b75956c9e3ee7a3b7b5c7.svg";
export { ForwardRef as ReactComponent };